var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 363,
    viewBox: "0 0 438 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1740_46347)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M35.8833 337.51C39.031 339.854 44.5629 341.542 50.0145 343.149H503.873C504.57 342.72 505.24 342.265 505.869 341.742C509.847 338.434 511.95 333.424 513.732 328.575C522.345 305.121 527.006 279.831 523.992 255.038C520.978 230.23 509.767 205.946 490.64 189.885C480.889 181.688 469.302 175.74 460.154 166.859C432.052 139.614 431.65 90.2276 399.396 68.0592C384.542 57.8389 365.508 55.6555 347.506 56.8477C330.696 57.9594 313.819 61.8439 299.273 70.3363C284.083 79.2037 272.162 92.5985 259.545 104.841C234.242 129.407 203.502 150.732 168.489 154.818C146.214 157.416 123.657 152.862 101.275 154.228C76.8436 155.715 52.8943 164.448 33.2178 179.022C20.6269 188.358 9.5497 200.414 4.07135 215.108C-4.01892 236.847 1.08438 261.239 8.90676 283.073C14.3181 298.156 22.7567 327.718 35.8833 337.51Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M492.675 275.599C480.741 297.981 468.726 320.324 456.778 342.707C455.171 345.721 453.456 348.855 450.63 350.77C446.987 353.249 442.245 353.208 437.838 353.088C413.956 352.405 390.14 351.976 366.258 351.762C311.287 351.266 256.302 350.757 201.331 350.261C176.659 350.034 152 349.806 127.327 349.592C111.186 349.444 95.1399 350.061 79.0397 350.114C70.8556 350.141 62.1626 348.574 56.1083 343.055C51.072 338.474 48.5538 331.803 46.3571 325.361C34.57 290.641 27.4843 254.355 25.301 217.76C23.4257 186.376 30.4177 154.67 55.5457 133.546C64.9085 125.67 76.0259 119.964 84.8127 111.445C111.789 85.2983 112.164 37.8806 143.132 16.5962C157.397 6.79118 175.668 4.68819 192.933 5.84015C209.073 6.91173 225.267 10.6355 239.238 18.793C253.824 27.3121 265.25 40.1577 277.372 51.9184C301.656 75.4933 331.164 95.974 364.784 99.8987C386.175 102.39 407.821 98.0234 429.306 99.3361C452.76 100.769 475.758 109.141 494.631 123.139C506.726 132.1 517.361 143.673 522.598 157.778C534.064 188.599 521.567 220.934 507.088 248.38C502.333 257.449 497.511 266.53 492.675 275.599Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.013 164.85C301.884 160.135 309.948 156.626 314.06 149.486C317.074 144.276 317.408 138.007 318.319 132.06C319.23 126.112 321.119 119.763 326.035 116.281C330.08 113.414 335.384 113.093 340.34 113.307C345.296 113.521 350.359 114.164 355.141 112.865C362.91 110.748 363.285 103.81 368.428 98.9744C374.201 93.5495 385.841 87.7496 392.833 94.1791C400.24 100.997 395.257 114.499 387.944 119.12C383.082 122.188 377.215 124.813 375.206 130.198C372.192 138.302 379.773 148.294 375.072 155.554C371.603 160.912 363.673 161.006 358.717 165.038C353.815 169.029 352.743 176.129 353.373 182.411C354.002 188.693 355.971 194.868 355.73 201.19C355.248 214.116 343.461 220.05 331.834 219.916C321.146 219.796 299.808 212.964 299.808 212.964C292.789 208.25 285.998 199.221 283.695 190.702C281.953 184.259 283.36 177.053 287.405 171.735C289.481 168.989 292.146 166.806 295.013 164.85Z",
    fill: "#C2CEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.773 104.841C379.773 104.841 327.91 152.259 307.336 214.585",
    stroke: "#4F6B7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.52 233.913C392.52 233.913 410.522 244.066 410.214 237.449C409.946 231.528 395.962 233.377 393.042 233.832C392.707 233.886 392.52 233.913 392.52 233.913Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.695 233.698C392.695 233.698 402.848 215.696 396.231 216.004C389.614 216.299 392.695 233.698 392.695 233.698Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27 241.816C381.27 241.816 399.272 251.969 398.964 245.352C398.669 238.748 381.27 241.816 381.27 241.816Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.215 241.856C381.215 241.856 391.368 223.853 384.752 224.161C378.148 224.456 381.215 241.856 381.215 241.856Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.268 249.719C372.268 249.719 388.06 258.626 387.792 252.826C387.524 247.013 372.268 249.719 372.268 249.719Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.321 249.866C372.321 249.866 381.229 234.074 375.429 234.341C369.629 234.596 372.321 249.866 372.321 249.866Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.299 258.318C364.299 258.318 380.051 264.681 379.1 259.323C378.162 253.965 364.299 258.318 364.299 258.318Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.553 258.546C364.553 258.546 370.915 242.794 365.558 243.745C360.2 244.682 364.553 258.546 364.553 258.546Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.455 267.641C357.455 267.641 374.319 269.717 372.015 264.788C369.724 259.859 357.455 267.641 357.455 267.641Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.668 267.628C357.668 267.628 359.745 250.764 354.815 253.067C349.886 255.358 357.668 267.628 357.668 267.628Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.096 276.669C352.096 276.669 366.709 278.477 364.713 274.191C362.718 269.932 352.096 276.669 352.096 276.669Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.458 276.749C352.458 276.749 354.266 262.136 349.98 264.132C345.707 266.114 352.458 276.749 352.458 276.749Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.506 283.943C348.506 283.943 360.99 285.483 359.288 281.826C357.587 278.169 348.506 283.943 348.506 283.943Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.881 284.063C348.881 284.063 350.421 271.579 346.765 273.28C343.121 274.981 348.881 284.063 348.881 284.063Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.715 234.462C391.715 234.462 411.512 226.371 409.422 222.688C407.333 219.018 391.715 234.462 391.715 234.462Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.627 231.957C395.627 231.957 352.068 254.648 343 303.486",
    stroke: "#70839B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.699 283.913C141.699 283.913 123.697 294.066 124.005 287.449C124.273 281.528 138.257 283.377 141.177 283.832C141.512 283.886 141.699 283.913 141.699 283.913Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.524 283.698C141.524 283.698 131.371 265.696 137.988 266.004C144.605 266.299 141.524 283.698 141.524 283.698Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.949 291.816C152.949 291.816 134.947 301.969 135.255 295.352C135.55 288.748 152.949 291.816 152.949 291.816Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.003 291.856C153.003 291.856 142.85 273.853 149.467 274.161C156.071 274.456 153.003 291.856 153.003 291.856Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.951 299.719C161.951 299.719 146.159 308.626 146.427 302.826C146.695 297.013 161.951 299.719 161.951 299.719Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.897 299.866C161.897 299.866 152.99 284.074 158.79 284.341C164.59 284.596 161.897 299.866 161.897 299.866Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92 308.318C169.92 308.318 154.168 314.681 155.119 309.323C156.057 303.965 169.92 308.318 169.92 308.318Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.666 308.546C169.666 308.546 163.303 292.794 168.661 293.745C174.019 294.682 169.666 308.546 169.666 308.546Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.764 317.641C176.764 317.641 159.9 319.717 162.204 314.788C164.494 309.859 176.764 317.641 176.764 317.641Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55 317.628C176.55 317.628 174.474 300.764 179.403 303.067C184.332 305.358 176.55 317.628 176.55 317.628Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.123 326.669C182.123 326.669 167.51 328.477 169.505 324.191C171.501 319.932 182.123 326.669 182.123 326.669Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.761 326.749C181.761 326.749 179.953 312.136 184.239 314.132C188.512 316.114 181.761 326.749 181.761 326.749Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.713 333.943C185.713 333.943 173.229 335.483 174.93 331.826C176.631 328.169 185.713 333.943 185.713 333.943Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.338 334.063C185.338 334.063 183.797 321.579 187.454 323.28C191.097 324.981 185.338 334.063 185.338 334.063Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.504 284.462C142.504 284.462 122.707 276.371 124.796 272.688C126.886 269.018 142.504 284.462 142.504 284.462Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.592 281.957C138.592 281.957 182.151 304.648 191.219 353.486",
    stroke: "#70839B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.699 110.913C177.699 110.913 159.697 121.066 160.005 114.449C160.273 108.528 174.257 110.377 177.177 110.832C177.512 110.886 177.699 110.913 177.699 110.913Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.524 110.698C177.524 110.698 167.371 92.6958 173.988 93.0039C180.605 93.2986 177.524 110.698 177.524 110.698Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.949 118.816C188.949 118.816 170.947 128.969 171.255 122.352C171.55 115.748 188.949 118.816 188.949 118.816Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.003 118.856C189.003 118.856 178.85 100.853 185.467 101.161C192.071 101.456 189.003 118.856 189.003 118.856Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.951 126.719C197.951 126.719 182.159 135.626 182.427 129.826C182.695 124.013 197.951 126.719 197.951 126.719Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.897 126.866C197.897 126.866 188.99 111.074 194.79 111.341C200.59 111.596 197.897 126.866 197.897 126.866Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.92 135.318C205.92 135.318 190.168 141.681 191.119 136.323C192.057 130.965 205.92 135.318 205.92 135.318Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.666 135.546C205.666 135.546 199.303 119.794 204.661 120.745C210.019 121.682 205.666 135.546 205.666 135.546Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.764 144.641C212.764 144.641 195.9 146.717 198.204 141.788C200.494 136.859 212.764 144.641 212.764 144.641Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.55 144.628C212.55 144.628 210.474 127.764 215.403 130.067C220.332 132.358 212.55 144.628 212.55 144.628Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.123 153.669C218.123 153.669 203.51 155.477 205.505 151.191C207.501 146.932 218.123 153.669 218.123 153.669Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.761 153.749C217.761 153.749 215.953 139.136 220.239 141.132C224.512 143.114 217.761 153.749 217.761 153.749Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.713 160.943C221.713 160.943 209.229 162.483 210.93 158.826C212.631 155.169 221.713 160.943 221.713 160.943Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.338 161.063C221.338 161.063 219.797 148.579 223.454 150.28C227.097 151.981 221.338 161.063 221.338 161.063Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.504 111.462C178.504 111.462 158.707 103.371 160.796 99.6879C162.886 96.0177 178.504 111.462 178.504 111.462Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.592 108.957C174.592 108.957 218.151 131.648 227.219 180.486",
    stroke: "#70839B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.893 158.34C294.893 158.34 316.444 171.883 316.471 163.725C316.484 155.581 294.893 158.34 294.893 158.34Z",
    fill: "#8424BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.949 167.087C283.949 167.087 302.353 178.66 302.38 171.695C302.393 164.716 283.949 167.087 283.949 167.087Z",
    fill: "#8424BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.458 167.556C284.458 167.556 296.031 149.151 289.066 149.125C282.101 149.111 284.458 167.556 284.458 167.556Z",
    fill: "#8424BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.253 203.427C205.539 202.865 194.863 171.494 194.167 169.833C183.813 145.039 168.342 124.867 149.63 111.807C115.046 87.6692 74.6479 90.1338 35.8574 99.4165C40.666 99.537 45.0193 102.564 48.9572 105.98C74.7015 128.323 88.3638 169.07 114.898 189.818C140.616 209.91 174.236 216.353 204.253 203.427Z",
    fill: "#EDC9AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.875 196.636C188.875 196.636 141.191 114.553 55.627 103.288",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.415 100.85L120.109 126.849L77.0586 128.684",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.365 122.469L152.831 152.5L116.639 154.402",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 150.116L178.335 181.112L141.688 177.749",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.035 195.565L209.141 210.54L170.19 309.474L166.145 294.807L161.832 249.653L178.481 200.44L215.035 195.565Z",
    fill: "#F7CFBA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M209.141 210.54L170.19 309.474L166.145 294.807L205.029 209.669L209.141 210.54Z",
    fill: "#B187F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.042 267.2L342.898 293.079L339.643 309.474L300.692 210.54L294.785 195.565L331.339 200.44L348.042 267.2Z",
    fill: "#F7CFBA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M342.897 293.079L339.643 309.474L300.691 210.54L304.804 209.669L342.897 293.079Z",
    fill: "#B187F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.858 211.183C298.804 234.088 299.233 265.847 299.233 265.847L286.307 266.048L266.818 266.356L244.101 266.705L241.409 266.731L229.555 266.919L211.445 267.2C211.445 266.37 211.418 265.526 211.392 264.682C211.378 264.24 211.365 263.798 211.365 263.369C211.338 262.713 211.311 262.057 211.271 261.427C211.217 260.476 211.164 259.512 211.124 258.56C211.003 256.833 210.869 255.118 210.708 253.417C210.682 253.149 210.655 252.894 210.641 252.627C210.628 252.252 210.615 251.85 210.615 251.488C210.588 250.832 210.561 250.189 210.521 249.546C210.467 248.595 210.414 247.63 210.36 246.679C210.253 244.951 210.119 243.237 209.958 241.536C209.918 241.04 209.878 240.558 209.838 240.062C209.771 239.5 209.731 238.95 209.664 238.388C209.61 237.879 209.557 237.343 209.503 236.847C209.409 236.017 209.329 235.2 209.222 234.383C209.195 234.182 209.168 233.981 209.141 233.78C209.074 233.271 209.021 232.775 208.954 232.266C208.887 231.757 208.833 231.262 208.753 230.78C208.686 230.271 208.605 229.775 208.552 229.293C208.485 228.811 208.405 228.315 208.338 227.833C208.271 227.364 208.204 226.882 208.123 226.399C208.056 225.917 207.976 225.448 207.896 224.993C207.681 223.6 207.454 222.247 207.226 220.921C207.159 220.546 207.105 220.184 207.025 219.809C206.851 218.778 206.65 217.773 206.462 216.782C206.355 216.193 206.235 215.63 206.128 215.067C205.86 213.688 205.592 212.375 205.337 211.143C191.594 209.924 176.352 202.905 176.352 202.905L194.916 160.51C199.055 153.92 216.187 148.75 228.496 145.803C235.89 144.048 241.556 143.07 241.596 143.057L241.61 143.03L241.918 143.057L255.178 144.262L269.216 143.03V143.057C269.35 143.084 309.279 149.942 315.909 160.524L334.474 202.918C334.5 202.892 318.762 210.138 304.858 211.183Z",
    fill: "#FF9341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.243 114.606V145.776C269.243 145.776 265.975 148.227 258.594 148.669C257.871 148.71 257.107 148.736 256.304 148.736C251.174 148.736 247.383 147.919 244.959 147.156C242.748 146.459 241.637 145.79 241.637 145.79V117.928L269.243 114.606Z",
    fill: "#E2BFAF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M258.594 148.669C257.871 148.709 257.107 148.736 256.304 148.736C251.174 148.736 247.383 147.919 244.959 147.156C242.748 146.459 241.637 145.789 241.637 145.789V120.152L252.714 125.469C252.701 125.469 250.223 140.619 258.594 148.669Z",
    fill: "#B187F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.162 84.7893C222.51 89.6382 220.554 93.737 217.808 93.938C215.049 94.1389 212.531 90.3616 212.183 85.5126C211.834 80.6637 213.79 76.5649 216.536 76.364C219.295 76.163 221.813 79.9404 222.162 84.7893Z",
    fill: "#FFAF2A",
    stroke: "#7B21AC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M214.046 83.2623C214.796 82.539 215.907 82.5122 216.778 83.048C217.783 83.6507 218.171 84.8429 218.493 85.9011C218.72 86.6378 217.555 86.9593 217.341 86.2226C217.153 85.5796 216.966 84.8697 216.497 84.3607C216.095 83.932 215.358 83.6373 214.889 84.1062C214.34 84.642 213.496 83.7981 214.046 83.2623Z",
    fill: "#FDE16C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.023 84.7893C287.674 89.6382 289.63 93.737 292.376 93.938C295.135 94.1389 297.653 90.3616 298.001 85.5126C298.35 80.6637 296.394 76.5649 293.648 76.364C290.889 76.163 288.384 79.9404 288.023 84.7893Z",
    fill: "#E8C0AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M296.14 83.2623C295.39 82.539 294.279 82.5122 293.408 83.048C292.403 83.6507 292.015 84.8429 291.693 85.9011C291.466 86.6378 292.631 86.9593 292.845 86.2226C293.033 85.5796 293.22 84.8697 293.689 84.3607C294.091 83.932 294.828 83.6373 295.297 84.1062C295.846 84.642 296.703 83.7981 296.14 83.2623Z",
    fill: "#E2BBAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.006 72.4527C293.033 73.8189 293.033 75.1718 293.006 76.4845C292.979 77.1275 292.966 77.757 292.939 78.3866C292.778 82.9408 292.323 87.2004 291.613 91.1652C288.733 106.958 281.594 117.968 272.03 123.514C271.2 124.05 270.316 124.505 269.445 124.907C269.378 124.934 269.311 124.974 269.244 125.001C265.547 126.662 261.542 127.559 257.336 127.693C254.041 127.8 250.773 127.425 247.639 126.595C245.589 126.059 243.58 125.335 241.638 124.398C241.008 124.103 240.379 123.782 239.763 123.433C238.745 122.871 237.767 122.241 236.789 121.558C228.819 115.972 222.524 106.516 219.591 93.0941C218.425 87.629 217.809 81.4942 217.876 74.6896C217.836 73.1358 217.849 71.582 217.916 70.055C217.916 70.0282 217.916 70.0282 217.943 70.0014C218.787 54.1017 226.435 40.4256 237.512 33.313C238.276 32.8173 239.053 32.3619 239.843 31.9333C244.196 29.5356 249.005 28.1693 254.108 28.0354C260.939 27.8345 267.396 29.8437 273.035 33.5541C283.054 40.1309 290.421 52.0255 292.47 66.1571L292.524 66.6527C292.792 68.5414 292.952 70.4836 293.006 72.4527Z",
    fill: "#F7CFBA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M257.323 127.693C254.028 127.8 250.759 127.425 247.625 126.595C245.576 126.059 243.567 125.335 241.624 124.398C240.995 124.103 240.365 123.782 239.749 123.433C238.731 122.871 237.753 122.241 236.775 121.558C228.806 115.972 222.51 106.516 219.577 93.0941C218.412 87.629 217.795 81.4942 217.862 74.6896C217.822 73.1358 217.836 71.582 217.903 70.055C217.903 70.0282 217.903 70.0282 217.929 70.0014C218.773 54.1017 226.422 40.4256 237.499 33.313L240.285 44.8593C240.285 44.8593 226.636 98.3181 241.638 119.348C245.134 124.264 250.183 127.412 257.323 127.693Z",
    fill: "#B187F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.177 23.6821C285.101 21.5389 287.754 17.3865 287.754 12.6045C287.754 5.63922 282.114 0 275.149 0C268.184 0 262.545 5.63922 262.545 12.6045C262.545 12.9662 262.572 13.3145 262.599 13.6627C262.492 13.6359 262.398 13.6225 262.304 13.5958C250.57 11.3454 241.382 13.0198 234.256 17.3329C230.546 19.1546 226.969 22.4096 223.661 27.5264C220.433 32.2012 217.982 37.7065 216.2 43.6805C216.039 44.2297 215.892 44.7789 215.758 45.3415C215.102 47.4177 214.472 49.6011 213.869 51.9318C193.537 130.586 235.662 140.78 235.662 140.78C220.982 125.523 220.741 96.4696 222.777 75.7344C272.31 66.5723 272.39 44.8325 272.39 44.8325C273.261 71.5284 293.634 76.3773 293.634 76.3773C293.634 76.3773 298.389 41.8455 281.177 23.6821Z",
    fill: "#44546A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.729 342.372H177.317C166.709 342.372 158.109 333.772 158.109 323.164V246.358C158.109 235.749 166.709 227.15 177.317 227.15H334.729C345.338 227.15 353.937 235.749 353.937 246.358V323.164C353.95 333.772 345.338 342.372 334.729 342.372Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1914 284.511C81.1914 284.511 85.558 254.212 99.0329 240.924",
    stroke: "#44546A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8848 244.447C96.0991 244.326 96.3268 243.161 96.3937 242.933C96.8759 241.58 97.3849 240.227 97.9341 238.901C99.595 234.816 101.484 230.811 103.747 227.02C106.359 222.64 109.561 218.086 114.021 215.42C116.244 214.094 119.446 213.438 122.017 213.639C126.317 213.96 129.411 217.604 127.228 221.689C125.406 225.105 121.843 227.301 118.897 229.632C114.316 233.262 109.4 236.464 104.417 239.491C101.618 241.205 98.778 242.88 95.8848 244.447Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3008 297.169C90.3008 297.169 92.0153 273.554 105.477 260.266",
    stroke: "#44546A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66 264.552C101.982 264.378 102.33 262.664 102.45 262.329C103.147 260.48 103.91 258.672 104.754 256.891C106.804 252.591 109.349 247.97 113.206 245.009C115.644 243.148 122.649 241.205 124.042 245.532C124.283 246.269 124.096 247.072 123.788 247.796C122.703 250.354 120.345 252.122 118.242 253.81C115.912 255.698 113.434 257.4 110.916 259.034C107.902 260.976 104.821 262.838 101.66 264.552Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2695 238.687C60.2695 238.687 74.173 250.528 80.6024 287.752",
    stroke: "#44546A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.369 243.389C64.0743 243.214 63.7931 242.143 63.6591 241.848C63.0162 240.469 62.3599 239.116 61.6768 237.749C59.6006 233.584 57.3905 229.485 54.9661 225.52C52.4747 221.434 49.7556 217.336 46.3534 213.947C44.3041 211.911 41.1296 209.151 37.9819 210.25C35.9727 210.96 34.1912 213.331 33.9501 215.367C33.5483 218.662 36.7898 222.037 38.9061 224.247C41.1832 226.618 43.6879 228.761 46.2463 230.811C50.9745 234.588 55.9707 238.044 61.0606 241.312C62.159 242.022 63.2573 242.719 64.369 243.389Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8166 285.314C74.8166 285.314 68.8426 267.794 76.7722 250.608",
    stroke: "#44546A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5924 253.729C75.3914 250.488 75.512 247.179 75.8335 243.951C76.3157 238.995 77.2265 232.927 80.8296 229.177C82.5575 227.382 84.9819 226.471 87.4733 226.752C96.26 227.77 80.5215 247.621 78.365 250.341C77.4542 251.479 76.53 252.618 75.5924 253.729Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5747 284.605C74.5747 284.605 62.868 264.017 44.9863 257.828",
    stroke: "#44546A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9208 262.155C53.5591 262.115 52.6081 260.628 52.3804 260.36C51.0678 258.886 49.6881 257.467 48.2415 256.114C43.4865 251.626 35.5301 244.701 28.6052 248.773C27.8149 249.242 27.0782 249.832 26.596 250.608C24.0778 254.573 30.1857 256.623 32.8914 257.601C35.7846 258.645 38.785 259.395 41.7854 260.052C45.7903 260.936 49.8354 261.632 53.9074 262.155C53.894 262.155 53.9074 262.155 53.9208 262.155Z",
    fill: "#70839B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.542 276.903H58.6484V338.72H102.542V276.903Z",
    fill: "#F3B083"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M100.48 338.706H58.6621V276.889C58.6487 276.903 64.5691 333.79 100.48 338.706Z",
    fill: "#B187F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M502.535 363.121H26.7755C20.1586 363.121 14.8008 357.763 14.8008 351.146C14.8008 344.529 20.1586 339.171 26.7755 339.171H502.535C509.151 339.171 514.509 344.529 514.509 351.146C514.509 357.763 509.151 363.121 502.535 363.121Z",
    fill: "#53667A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43 105.431C259.144 104.614 250.545 103.02 249.514 103.596C248.402 104.212 247.933 105.685 248.241 106.931C248.536 108.177 249.46 109.195 250.505 109.905C252.902 111.539 256.171 111.807 258.796 110.574C259.801 110.106 260.738 109.396 261.167 108.378C261.595 107.373 261.354 106.02 260.43 105.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M241.61 143.03L241.395 143.164C241.395 143.164 197.247 152.969 196.269 160.47L179.754 201.365L186.451 204.044L200.649 165.868C200.649 165.868 204.494 156.626 242.708 153.947C242.708 153.947 260.215 153.411 265.211 147.691C265.211 147.691 246.82 151.536 241.61 143.03Z",
    fill: "#B187F4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M266.109 226.279C266.109 226.279 283.964 193.06 283.964 165.198C283.964 165.198 295.39 176.276 303.252 211.638L300.748 227.002L266.109 226.279Z",
    fill: "#B187F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1740_46347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 363,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStart);
export default __webpack_public_path__ + "static/media/user-start.ca0ac691fe17c6c17096b3f6c084fd49.svg";
export { ForwardRef as ReactComponent };